module.exports = __webpack_public_path__ + "img/taken_scanning.affdd074.svg";